export default __webpack_public_path__ + "static/media/livecase2.aa8fb43c.png";